<template>
  <v-container fluid class="av-page">
    <!-- FILTROS -->
    <div class="av-card av-filtro-card">
      <span class="av-section-label">Filtros</span>
      <v-row dense align="end">
        <v-col cols="12" sm="6" md="3" v-if="user.tipo == 'ADMIN'">
          <label class="av-field-label">Empresa</label>
          <v-autocomplete
            outlined
            dense
            hide-details
            v-model="empresaSelecionada"
            :items="empresas"
            item-text="nome"
            item-value="id"
            placeholder="Selecione a empresa"
            no-data-text="Nenhuma empresa encontrada"
            @input="questionarioSelecionado = ''; carregaQuestionarios(empresaSelecionada)"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <label class="av-field-label">Questionário</label>
          <v-autocomplete
            outlined
            dense
            hide-details
            v-model="questionarioSelecionado"
            :items="questionarios"
            item-text="titulo"
            item-value="id"
            placeholder="Selecione o questionário"
            no-data-text="Nenhum questionário encontrado"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <label class="av-field-label">Data Início</label>
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                light
                v-model="dateFormattedInicio"
                append-icon="event"
                @blur="date = parseDate(dateFormattedInicio)"
                v-on="on"
                outlined
                dense
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker v-model="dataInicio" no-title @input="menu1 = false" locale="pt-br"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <label class="av-field-label">Data Fim</label>
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                light
                v-model="dateFormattedFim"
                append-icon="event"
                @blur="date = parseDate(dateFormattedFim)"
                v-on="on"
                outlined
                dense
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker v-model="dataFim" no-title @input="menu2 = false" locale="pt-br"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-btn block depressed color="primary" :disabled="user.tipo == 'ADMIN' ? empresaSelecionada == '' : false" @click="carregaProfissionais(questionarioSelecionado)">
            <v-icon left>mdi-magnify</v-icon>Buscar
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <div class="av-card av-panel">
      <div class="av-toolbar">
        <v-text-field
          v-model="tabela.busca"
          append-icon="search"
          label="Procurar"
          outlined
          dense
          hide-details
          single-line
          class="av-busca"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn depressed color="primary" :disabled="desativaExportacaoAvaliacoesGeral">
          <download-csv :data="listaAvaliacoesGeral" encoding="UTF-8" name="Relatorio Geral de Avaliações.csv" :separator-excel="true">
            <span class="av-export-label"><v-icon left small>cloud_download</v-icon>Baixar relatório</span>
          </download-csv>
        </v-btn>
      </div>

      <v-data-table
        :search="tabela.busca"
        :headers="tabela.cabecalho"
        :items="tabela.conteudo"
        :loading="tabela.carregamento"
        loading-text="Buscando avaliações..."
        sort-by="nome"
        class="av-table"
        :footer-props="{
          'items-per-page-text': 'Linhas por página',
          'items-per-page-all-text': 'Tudo',
        }"
      >
        <template v-slot:[`item.action`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon small v-on="on" @click="verDetalhes(item)">
                <v-icon small color="primary">mdi-eye</v-icon>
              </v-btn>
            </template>
            <span>Ver detalhes</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.media`]="{ item }">
          <div class="d-flex align-center" v-if="parseInt(item.media) >= 1">
            <v-rating
              color="warning"
              empty-icon="mdi-star-outline"
              full-icon="mdi-star"
              half-icon="mdi-star-half-full"
              half-increments
              length="5"
              size="20"
              :value="item.media ? (parseInt(item.media) / 2) : 0"
              readonly
            ></v-rating>
            <span class="av-media-valor">({{ (item.media.toFixed(1).replace('.',',')) }})</span>
          </div>
          <span class="av-media-vazio" v-else>Não avaliado no período</span>
        </template>
        <template v-slot:no-data>
          <v-alert v-if="empresaSelecionada == ''" dense text outlined type="info" class="my-4">
            Selecione uma empresa para visualizar as avaliações
          </v-alert>
          <v-alert v-else dense text outlined type="warning" class="my-4">
            Nenhuma avaliação encontrada
          </v-alert>
        </template>
      </v-data-table>
    </div>

    <v-dialog v-model="dialogoDetalhes" persistent max-width="800px" scrollable>
      <v-card>
        <v-card-title class="av-dialog-title">Avaliações de {{ tabelaDetalhes.nomeProfissional }}</v-card-title>
        <p class="av-dialog-hint">Período de {{ dateFormattedInicio }} a {{ dateFormattedFim }}</p>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <div class="av-gauge-box">
            <VueSvgGauge
              :start-angle="-90"
              :end-angle="90"
              :value="tabelaDetalhes.media ? tabelaDetalhes.media : 0"
              :separator-step="1"
              :min="0"
              :max="10"
              :gauge-color="[{ offset: 0, color: '#B71C1C'},{ offset: 50, color: '#FFEA00'},{ offset: 100, color: '#1B5E20'}]"
              :scale-interval="1.0"
            >
              <div class="inner-text" style="text-align: center">
                <span style="position: absolute; bottom: 0; left: 50%; transform: translateX(-50%); font-weight: bold" v-if="tabelaDetalhes.media">Média: {{ tabelaDetalhes.media.toFixed(1).replace('.',',') }}</span>
                <span style="position: absolute; bottom: 0; left: 50%; transform: translateX(-50%); font-weight: bold" v-else>Não avaliado</span>
              </div>
            </VueSvgGauge>
          </div>

          <div class="av-toolbar mt-4">
            <v-text-field
              v-model="tabela.busca"
              append-icon="search"
              label="Procurar"
              outlined
              dense
              hide-details
              single-line
              class="av-busca"
            ></v-text-field>
          </div>
          <v-data-table
            :search="tabelaDetalhes.busca"
            :headers="tabelaDetalhes.cabecalho"
            :items="tabelaDetalhes.conteudo"
            class="av-table"
            :footer-props="{
              'items-per-page-text': 'Linhas por página',
              'items-per-page-all-text': 'Tudo',
            }"
          >
            <template v-slot:[`item.created`]="{ item }">
              <span>{{ transformaData(item.created, 'DD/MM/YYYY') }} às {{ transformaData(item.created, 'HH:mm:ss') }}</span>
            </template>
            <template v-slot:no-data>
              <v-alert dense text outlined type="warning" class="my-4">Nenhuma avaliação encontrada</v-alert>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text color="primary" :disabled="desativaExportacaoAvaliacoesIndividual">
            <download-csv :data="listaAvaliacoesIndividual" encoding="UTF-8" :name="'Relatorio Individual ' + tabelaDetalhes.nomeProfissional + '.csv'" :separator-excel="true">
              <span class="av-export-label"><v-icon left small>cloud_download</v-icon>Baixar relatório</span>
            </download-csv>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogoDetalhes = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import { VueSvgGauge } from 'vue-svg-gauge'
  import moment from 'moment'

  export default {
    components: { Snackbar, VueSvgGauge, },
    data: vm => ({
      addQuest: false,
      dialogoDetalhes: false,
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'nome', },
          { text: 'Média', align: 'start', value: 'media', },
          { text: 'Setor', align: 'start', value: 'local', },
          { text: 'Questionário', align: 'start', value: 'questionario', },
          { text: 'Detalhes', value: 'action', sortable: false },
        ],
        carregamento: false,
        conteudo: [],
      },
      empresas: [],
      questionarios: [],
      empresaSelecionada: '',
      questionarioSelecionado: '',
      tabelaDetalhes: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'clienteNome', },
          { text: 'Telefone', align: 'start', value: 'clienteTelefone', },
          { text: 'Nota', align: 'start', value: 'nota', },
          { text: 'Enviado em', align: 'start', value: 'envioMensagem', },
        ],
        conteudo: [],
        media: 0,
        nomeProfissional: '',
      },
      menu1: false,
      menu2: false,
      dateFormattedInicio: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      dateFormattedFim: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      dataInicio: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dataFim: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      listaAvaliacoesGeral: [],
      listaAvaliacoesIndividual: [],
      desativaExportacaoAvaliacoesGeral: true,
      desativaExportacaoAvaliacoesIndividual: true,
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
    }),

    watch: {
      dialogoDetalhes(val) {
        if (val == false) {
          setTimeout(() => {
            this.tabelaDetalhes.conteudo = []
            this.tabelaDetalhes.media = 0
            this.tabelaDetalhes.nomeProfissional = ''
          }, 300);
        }
      },

      dataInicio() {
        this.dateFormattedInicio = this.formatDate(this.dataInicio)
      },

      dataFim() {
        this.dateFormattedFim = this.formatDate(this.dataFim)
      },
    },

    mounted() {
      if (this.user.tipo == 'ADMIN') {
        this.carregaEmpresas()
      } else {
        this.carregaQuestionarios(this.companyobj.id)
      }
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaQuestionarios(empresaId) {
        await axios.get(baseApiUrl + 'Questionarios?filter={"where":{"empresaId":"' + empresaId + '"}, "order": "titulo ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(async response => {
          if (response.data) {            
            this.questionarios = response.data

            if (this.companyobj.nome && this.companyobj.nome.toLowerCase().includes('roseanne')) {
              this.questionarios.push({
                'titulo': 'Todos',
                'id': 'Todos'
              })
            }
          }
        })
      },

      async carregaProfissionais (id) {
        this.tabela.carregamento = true
        this.tabela.conteudo = []
        this.listaAvaliacoesGeral = []
        this.desativaExportacaoAvaliacoesGeral = true
        let model = ''
        let dados = {
          "questionarioId": null,
          "dataInicio": this.dataInicio,
          "dataFim": this.dataFim
        }

        if (id == 'Todos') {
          let questionarioId = []

          // obtendo IDs dos questionários para enviar ao endpoint
          for (let i = 0; i < this.questionarios.length; i++) {
            if (this.questionarios[i].titulo != 'Todos') {
              questionarioId.push(this.questionarios[i].id)
            }
          }
          
          model = 'Profissionais/todos'
          dados.questionarioId = questionarioId
        } else {
          model = 'Profissionais/media'
          dados.questionarioId = id
        }

        await axios.post(baseApiUrl + model + '?access_token=' + sessionStorage.getItem('accToken'), dados)
        .then(async response => {
          if (response.data) {            
            this.tabela.conteudo = response.data
            this.tabela.carregamento = false

            this.listaExportacaoAvaliacoesGeral(response.data)
          }
        })
      },

      async pegaAvaliacoes(profissionalId) {
        let resposta

        await axios.get(baseApiUrl + 'ServiceNotas?filter={"where":{"and":[{"profissionalId":"' + profissionalId + '"},{"created":{"gte":"' + this.dataInicio + 'T00:00:00.000Z"}},{"created":{"lte":"' + this.dataFim + 'T23:59:59.999Z"}}]}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            resposta = response.data
          }
        })

        return resposta
      },

      async verDetalhes(item) {
        this.listaAvaliacoesIndividual = []
        this.desativaExportacaoAvaliacoesIndividual = true
        let dados = await this.pegaAvaliacoes(item.id)

        if (dados) {
          this.tabelaDetalhes.conteudo = dados
          this.tabelaDetalhes.media = this.calculaMedia(dados)
          this.tabelaDetalhes.nomeProfissional = item.nome
          this.dialogoDetalhes = true

          this.listaExportacaoAvaliacoesIndividual(dados)
        }
      },

      calculaMedia(lista) {
        let somaTotal = 0

        lista.forEach(avaliacao => {
          somaTotal += avaliacao.nota
        })

        return (somaTotal / lista.length)
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      transformaData(data, formato) {
        let date = moment(data).format(formato);
        return date
      },
      
      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      listaExportacaoAvaliacoesGeral(lista) {
        for (let i = 0; i < lista.length; i++) {
          this.listaAvaliacoesGeral.push({
            "Nome": lista[i].nome,
            "Média": lista[i].media ? lista[i].media.toFixed(1).replace('.',',') : 0,
            "Setor": lista[i].local ? lista[i].local : '',
            "Questionário": lista[i].questionario,
          })
        }

        this.desativaExportacaoAvaliacoesGeral = false
      },

      listaExportacaoAvaliacoesIndividual(lista) {
        for (let i = 0; i < lista.length; i++) {
          let item = {
            "Nome": lista[i].clienteNome,
            "Telefone": lista[i].clienteTelefone,
            "Nota": lista[i].nota,
          }
          
          if (lista[i].envioMensagem) {
            item["Enviado em"] = this.transformaData(lista[i].envioMensagem, 'DD/MM/YYYY') + ' às ' + this.transformaData(lista[i].envioMensagem, 'HH:mm:ss')
          }
          
          this.listaAvaliacoesIndividual.push(item)
        }

        this.desativaExportacaoAvaliacoesIndividual = false
      },
    },
  }
</script>

<!-- Estilos globais legados (mantidos para telas ainda não migradas) -->
<style>
  .theme--light.v-data-table thead tr th {
    color: white;
  }
</style>

<style scoped>
  .av-page {
    padding: 20px 24px;
  }

  .av-filtro-card {
    padding: 16px;
    margin-bottom: 16px;
  }

  .av-panel {
    padding: 16px 16px 8px;
  }

  .av-section-label {
    display: block;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .4px;
    text-transform: uppercase;
    color: var(--av-text-soft);
    margin-bottom: 8px;
  }

  .av-field-label {
    display: block;
    font-size: 12.5px;
    font-weight: 500;
    color: #2c3a3a;
    margin-bottom: 6px;
  }

  .av-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
    flex-wrap: wrap;
  }

  .av-busca { max-width: 280px; }

  @media (max-width: 599px) {
    .av-toolbar {
      flex-direction: column;
      align-items: stretch;
    }

    .av-toolbar .v-spacer {
      display: none;
    }

    .av-busca {
      max-width: none;
    }

    .av-toolbar .v-btn {
      width: 100%;
    }
  }

  .av-dialog-title {
    font-size: 17px;
    font-weight: 600;
    color: var(--av-text);
    padding-bottom: 2px;
  }

  .av-dialog-hint {
    margin: 0;
    padding: 0 16px 12px;
    font-size: 13px;
    color: var(--av-text-soft);
  }

  /* Valor numérico ao lado das estrelas */
  .av-media-valor {
    margin-left: 8px;
    color: var(--av-text-soft);
    font-size: 13px;
  }

  .av-media-vazio {
    color: var(--av-text-soft);
    font-style: italic;
  }

  /* Caixa do medidor (gauge) */
  .av-gauge-box {
    border: 1px solid var(--av-border);
    padding: 10px;
    height: 200px;
  }

  /* Botão de exportação: mantém o conteúdo do download-csv alinhado */
  .av-export-label {
    display: inline-flex;
    align-items: center;
  }

  ::v-deep .av-export-label,
  ::v-deep .v-btn a {
    color: inherit;
    text-decoration: none;
  }

  /* Respiro confortável entre os filtros */
  ::v-deep .av-filtro-card .row > [class*="col"] {
    padding-top: 6px;
    padding-bottom: 6px;
  }

  /* Cabeçalho legível, sobrepondo o CSS global herdado das telas legadas */
  ::v-deep .av-table .v-data-table__wrapper > table > thead > tr > th {
    color: var(--av-text-soft) !important;
    background: #f7f9f9;
    font-size: 12.5px;
    font-weight: 600;
    white-space: nowrap;
    border-bottom: 1px solid var(--av-border) !important;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > thead > tr > th,
  ::v-deep .av-table .v-data-table__wrapper > table > tbody > tr > td {
    height: 46px;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > tbody > tr > td {
    border-bottom: 1px solid #eef1f1 !important;
    font-size: 13.5px;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > tbody > tr:hover {
    background: #f5f8f8;
  }

  ::v-deep .av-table.v-data-table {
    background: transparent;
  }
</style>